export default __webpack_public_path__ + "static/media/placeholder_dummy2016-modelportfolio01-de.7d7f3994.png";